/******************
* Javascript for 'workflow:' Kirby snippet
*
* Show/hide next/previous step in a visual workflow
*******************/

if(typeof FN == 'undefined') FN = {};



FN.workflowVisual = {
  init: function(){
    $('.steps-nav').click(FN.workflowVisual.navigateWorkflow);
  },
  
  navigateWorkflow: function(event){
    event.preventDefault();
    var navItem = $(this);
    var stepContainer = navItem.closest('.workflow');
    var currentItem = stepContainer.find('.step-content.current');
    var currentItemNo = currentItem.attr('step');
    var nextItem = stepContainer.find('.step-content[step="'+(parseInt(currentItemNo)+1)+'"]');
    var prevItem = stepContainer.find('.step-content[step="'+(parseInt(currentItemNo)-1)+'"]');

    if(navItem.hasClass('next') && nextItem.length == 1){
      showItem = nextItem.first();
      nudgeShownItem = "-=20";
      hideItem = currentItem;
    }else if(navItem.hasClass('prev') && prevItem.length == 1){
      showItem = prevItem;
      nudgeShownItem = "+=20";
      hideItem = currentItem;
    }else{
      showItem = false;
      hideItem = false;
    }

    if(showItem && hideItem){
      hideItem.animate({
          opacity: 0,
          left: nudgeShownItem
        }, 300, function() {
          $(this).css({'display':'none'}).removeClass('current');
          showItem.css({'display':'block'}).animate({
            opacity:1,
            left:0
          }, 300, function(){
            $(this).addClass('current');
          })
      });
    }
  }
};




$(document).ready(function(){
  FN.workflowVisual.init();
});
